import { insertMermaid } from './operations';

const slashMenu = {
  Mermaid: { icon: 'diagram', label: 'Mermaid Diagram', transform: insertMermaid },
};

export default slashMenu;
